import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { Button, Card, Form, Row, Col, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { nanoid } from "nanoid";

import { useSelector } from "react-redux";

import { SingleValue } from "react-select";

import _debounce from "lodash/debounce";
import { IExport } from "../../exports/dto/IExports";
import { IAllStates } from "../../../store/rootReducer";
import { ClientService } from "../../clients/service";
import { ContentService } from "../../content/service";
import { ErrorToast, SuccessToast } from "../../../shared/toasters/toasters";
import { AddForm } from "./AddForm";
import { DataHistoryList } from "./DataHistoryList";
import { Stepper } from "./Stepper";
import { ClientDashboardService } from "../service";
const defaultContentTitle = {
  title: "",
  location: "",
  documents: [
    {
      id: null,
      name: "",
      path: "",
      index: null,
    },
  ],
};
export const DataHistoryStep = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const [files, setFiles] = useState<any[]>([]);
  const [clientFilterId, setClientFilterId] = useState(null);
  const [contentId, setContentId] = useState(0 as number);

  const [termFilter, setTermFilter] = useState("");
  const [dataHistoryList, setDataHistoryList] = useState(undefined);
  const [triggerUpdate, setTriggerUpdate] = useState(false);
  const [documentFile, setDocumentFile] = useState<any>();
  const [clientList, setClientList] = useState<IExport[]>([]);
  const [userClientList, setUserClientList] = useState<any[]>([]);
  const { accessRights, roles } = useSelector(
    (state: IAllStates) => state.auth
  );
  const [createField, setCreateField] = useState(false);
  const [selectedContent, setSelectedContent] = useState({});
  const [show, setShow] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
    title: "",
    client: null,
  });

  const [contentTitle, setContentTitle] = useState(defaultContentTitle);
  const isManager = roles?.includes("ROLE_MANAGER");
  const isAdmin = roles?.includes("ROLE_ADMIN");
  const isCompanyAdmin = roles?.includes("ROLE_COMPANY_ADMIN");
  const superAdmin = roles?.includes("ROLE_SUPER_ADMIN");
  const userClientDashboardCanEdit = accessRights?.includes(
    "client_dashboard_can_edit"
  );
  const userClientDashboardCanView = accessRights?.includes(
    "client_dashboard_can_view"
  );
  const handleShow = () => setShow(true);
  const [clientParams, setClientParams] = useState({
    page: 1,
    perPage: 10,
  });
  const [translatorData, setTranslatorData] = useState<any>({ contents: [] });
  const [checkedValues, setCheckedValues] = useState<number[]>([]);
  const { id } = useParams();
  const { t } = useTranslation();
  const changeClientHandler = _debounce((targetValue: any) => {
    setClientParams((prev) => ({ ...prev, name: targetValue }));
  }, 200);
  const changeFilterHandler = _debounce(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const { value, name } = event.target;
      setTermFilter(value);
      setPagination({
        page: 1,
        perPage: 10,
        [name]: value,
        client: clientFilterId,
      } as any);
    },
    200
  );
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const handlePages = (updatePage: number) => {
    setPagination({ ...pagination, page: updatePage });
    setPage(updatePage);
  };

  const changeFilterClientHandler = (
    selectedSingle: SingleValue<IExport | null>,
    inputKey: string
  ) => {
    if (Number(selectedSingle?.value)) {
      setClientFilterId(selectedSingle?.value as any);
      setPagination({
        page: 1,
        perPage: 10,
        title: termFilter,
        client: clientFilterId,
      } as any);
    } else {
      setClientFilterId(null);
      setPagination({
        page: 1,
        perPage: 10,
        title: termFilter,
        client: null,
      } as any);
    }
    setClientFilterId(selectedSingle?.value as any);
    setPagination((prev) => ({ ...prev, [inputKey]: selectedSingle?.value }));
  };
  function handleSelectSingleClient(selectedSingle: SingleValue<any | null>) {
    setContentTitle((prev: any) => ({
      ...prev,
      client: {
        id: selectedSingle?.value as number,
        name: selectedSingle?.label as string,
      },
    }));
  }
  const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    // @ts-ignore
    const { name, value } = event.target;
    setContentTitle((prev: any) => ({ ...prev, [name]: value }));
  };

  const submitHandler = (event: React.FormEvent) => {
    event.preventDefault();
    if (contentId && contentId !== 0) {
      const formData = new FormData();
      if (contentTitle?.documents?.length > 0) {
        for (let i = 0; i < contentTitle?.documents?.length; i++) {
          if (files[i]?.size) {
            formData.append("documents", files[i]);
          }
        }
      }
      formData.append(
        "body",
        JSON.stringify({
          name: (contentTitle as any)?.name,
          client: (contentTitle as any)?.client,
        })
      );

      ClientDashboardService.updateDataHistoryById(contentId as any, formData)
        .then((response) => {
          if (response?.id) {
            SuccessToast("Success added Data history");
            setCreateField(false);
            setContentTitle(defaultContentTitle);
            setDocumentFile(undefined);
            setFiles([]);
            setTriggerUpdate((prev) => !prev);
          }
        })
        .catch((error) => ErrorToast(error));
    } else {
      const formData = new FormData();
      if (contentTitle?.documents?.length) {
        for (let i = 0; i < contentTitle?.documents?.length; i++) {
          formData.append("documents", files[i]);
        }
      }
      formData.append(
        "body",
        JSON.stringify({
          name: (contentTitle as any)?.name,
          client:
            userClientList?.length === 1
              ? userClientList[0]?.id
              : (contentTitle as any)?.client,
        })
      );

      ClientDashboardService.createDataHistory(formData)
        .then((response) => {
          if (response?.id) {
            SuccessToast("Success added content");
            setCreateField(false);
            setContentTitle(defaultContentTitle);
            setDocumentFile(undefined);
            setFiles([]);
            setTriggerUpdate((prev) => !prev);
          }
        })
        .catch((error) => ErrorToast(error));
    }
  };
  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      submitHandler(e);
    }
  };
  const handleFilesInput = (i: number, e: any, element: any) => {
    if (e.target.files.length) {
      let newFormValuesImg = [
        ...contentTitle.documents.map((file: any, index: any) =>
          index === i
            ? { ...file, index: files.length, name: e.target.files[0]?.name }
            : file
        ),
      ];
      (newFormValuesImg as any)[i][e.target.name] = URL.createObjectURL(
        e.target.files[0]
      );

      setFiles((prev: any) => [...prev, e.target.files[0]]);
      setContentTitle((prev: any) => ({
        ...prev,
        documents: newFormValuesImg,
      }));
    }
  };
  const addFormFields = () => {
    setContentTitle((prev: any) => ({
      ...prev,
      documents: [
        ...prev.documents,
        {
          id: null,
          path: "",
          name: "",
          index: null,
        },
      ],
    }));
    const newFormData = [...contentTitle.documents];
    const id = nanoid();
    newFormData.push({
      id: null,
      path: "",
      name: "",
      index: null,
    });
    setContentTitle((prev: any) => ({ ...prev, documents: newFormData }));
  };
  const removeFormFields = (index: any, id: any, item: any) => {
    if (contentTitle?.documents.length === 1) {
      setContentTitle((prev: any) => ({
        ...prev,
        documents: [
          ...prev.documents,
          {
            id: null,
            path: "",
            name: "",
            index: null,
          },
        ],
      }));
    }
    if (id === null) {
      setContentTitle((prev: any) => ({
        ...prev,
        documents: prev.documents.filter(
          (input: any, idx: any) => idx !== index
        ),
      }));
      setFiles((prev: any) =>
        prev.filter((input: any) => input?.path != item?.path)
      );
    } else {
      ClientDashboardService.deleteFile(id)
        .then((response) => {
          setContentTitle((prev: any) => ({
            ...prev,
            documents: prev.documents.filter(
              (input: any, idx: any) => idx != index
            ),
          }));
          SuccessToast(t(`toasts.successfully_deleted`));
        })
        .catch((error) => ErrorToast(error));
    }
  };
  const editHandler = (contentId: number) => {
    setShowUpdate(true);
    setCreateField(true);
    setContentId(contentId);
    ClientDashboardService.getDataHistoryById(+contentId!)
      .then((res) => {
        const filesArr =
          res?.documents?.length > 0
            ? res?.documents?.map((item: any) => ({
                source: item?.path, // Example URL of another default file
                options: {
                  type: "input",
                  file: {
                    name: item?.path,
                  },
                },
              }))
            : [
                {
                  id: null,
                  name: "",
                  path: "",
                  index: null,
                },
              ];

        setContentTitle({
          ...res,
          location: res?.source,
          documents:
            res?.documents?.length == 0
              ? [
                  {
                    id: null,
                    name: "",
                    path: "",
                    index: null,
                  },
                ]
              : res?.documents,
        });
        setFiles(filesArr);
      })
      .catch((err) => ErrorToast(err));
  };
  const checkAccess = () => {
    if (isManager || isAdmin || isCompanyAdmin) {
      return false;
    } else {
      return true;
    }
  };
  useEffect(() => {
    ClientService.getAllClients({
      page: 1,
      perPage: 0,
    })
      .then((response) => {
        const { data } = response;
        setClientList(
          data?.map((client) => ({
            ...client,
            label: client.name,
            value: client.id,
          }))
        );
      })
      .catch((error) => ErrorToast(error));
  }, [clientParams]);
  useEffect(() => {
    ClientDashboardService.getAllUsersClients()
      .then((response: any) => {
        const { data } = response;
        setUserClientList(
          (response?.length > 0 ? response : [])?.map((client: any) => ({
            ...client,
            label: client.name,
            value: client.id,
          }))
        );
      })
      .catch((error) => ErrorToast(error));
  }, []);
  const visibleCard = () => {
    if (!userClientDashboardCanEdit) {
      return false;
    } else {
      return true;
    }
  };
  useEffect(() => {
    ClientDashboardService.getAllDataHistory(pagination)
      .then((data: any) => {
        if (pagination?.page > 1 && pagination?.page > data?.totalPages) {
          setPage(data?.totalPages);
          setPagination({ ...pagination, page: data?.totalPages });
          setTotalPages(data?.totalPages);
          setDataHistoryList(data?.data);
        } else {
          setDataHistoryList(data?.data);
          setTotalPages(data?.totalPages);
        }
      })
      .catch((error) => ErrorToast(error));
  }, [triggerUpdate, pagination]);
  return (
    <>
      <Helmet>
        <title>{t("side_bar.client_dashboard")}</title>
      </Helmet>

      <Card>
        <Card.Body>
          {checkAccess() && <Stepper step={"data_history"} />}
          {(userClientDashboardCanEdit || userClientDashboardCanView) && (
            <div className="row">
              <div className="col-md-12">
                <AddForm
                  setContentId={setContentId}
                  setCreateField={setCreateField}
                  createField={createField}
                  submitHandler={submitHandler}
                  handleKeyDown={handleKeyDown}
                  contentTitle={contentTitle}
                  changeHandler={changeHandler}
                  handleFilesInput={handleFilesInput}
                  setContentTitle={setContentTitle}
                  defaultContentTitle={defaultContentTitle}
                  showUpdate={showUpdate}
                  removeFormFields={removeFormFields}
                  addFormFields={addFormFields}
                  handleSelectSingleClient={handleSelectSingleClient}
                  clientList={clientList}
                  userClientList={userClientList}
                />
              </div>
            </div>
          )}
        </Card.Body>
      </Card>

      <Card>
        {/* <Card.Body> */}
        <div className="row">
          <div className="col-md-12">
            <DataHistoryList
              pagination={pagination}
              setContentId={setContentId}
              setCreateField={setCreateField}
              accessRights={accessRights}
              page={page}
              handlePages={handlePages}
              totalPages={totalPages}
              dataHistoryList={dataHistoryList}
              setTriggerUpdate={setTriggerUpdate}
              clientList={clientList}
              changeFilterClientHandler={changeFilterClientHandler}
              changeFilterHandler={changeFilterHandler}
              changeClientHandler={changeClientHandler}
              editHandler={editHandler}
              userClientList={userClientList}
              userClientDashboardCanEdit={userClientDashboardCanEdit}
            />
          </div>
        </div>
        {/* </Card.Body> */}
      </Card>
    </>
  );
};
